import { FormCard, FormItem, Input } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import { NAMESPACE } from 'locale'
import { serviceUserProfileConstants as supConstants } from 'locale/serviceUserProfile'
import { useTranslation } from 'react-i18next'

export const EmailFormCard = () => {
  const { t } = useTranslation(NAMESPACE.SERVICE_USER_PROFILE)

  return (
    <FormCard>
      <FormItem
        label={<Text>{t(supConstants.EMAIL)}</Text>}
        name="email"
        rules={[
          {
            type: 'email',
            message: 'The input is not valid E-mail!'
          }
        ]}
      >
        <Input />
      </FormItem>
    </FormCard>
  )
}
